import React, { useState, useEffect, useContext } from "react";
import { Context } from '../../../context/UserContext'
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import ReverseService from "../../../services/ReverseService";
import CollectOrderService from "../../../services/CollectOrderService";
import TiposColeta from "../../../enums/TiposColeta";
import SgsService from "../../../services/SgsService";
import GmoService from "../../../services/GmoService";
import DepositService from './../../../services/DepositService';
import CompanyService from "../../../services/CompanyService"

export default function InitiateSingleCollectOrderModal({
  isModalOpen,
  setModalOpen,
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const { user } = useContext(Context)

  const filteredTiposColeta = user.role !== 'vivogestao'
    ? TiposColeta.filter(tipo => tipo.cod !== "05")
    : TiposColeta;

  const [searchResults, setSearchResults] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDevicesList, setShowDevicesList] = useState(false)
  const [gmoList, setGmoList] = useState([]);
  const [depositList, setDepositList] = useState([]);
  const [companiesList, setCompaniesList] = useState([])


  useEffect(() => {
    async function fetchRequest() {
      const gmos = await GmoService.getGmos();
      setGmoList(gmos)

      const deposits = await DepositService.getDeposits();
      setDepositList(deposits)
    }

    async function fetchCompanies() {
      const result = await CompanyService.getCompanies();
      setCompaniesList(result.companies)
    }

    fetchRequest();
    fetchCompanies();

    setValue("nomeSolicitante", user?.name)
    setValue("reLegalSolicitante", user?.reLegal)
    setValue("contatoSolicitante", user?.phone)

  }, [setValue, user?.name, user?.phone, user?.reLegal]);


  const handleInputChange = async (e) => {
    setShowDevicesList(true)
    const searchTerm = e.target.value;
    if (searchTerm.length >= 3) {
      try {
        const data = await SgsService.getSgsItems(`?name=${searchTerm}`);
        setSearchResults(data.result.data);
        // console.log(data.result.data)
      } catch (error) {
        console.error('Error fetching search results:', error);
      }
    } else {
      setSearchResults([]);
    }
  };

  const handleSelectItem = (item) => {
    setSelectedItem(item);
    setValue('codEquipamentoColeta', item.codigo);
    setValue('nomeEquipamentoColeta', item.nome);
    setValue('partNumberEquipamentoColeta', item.partNumber)
    setValue('fabricanteEquipamentoColeta', item.nomeFabricante)
    setValue('familiaEquipamentoColeta', item.nomeFamilia)
    setValue('grupoProdutoEquipamentoColeta', item.nomeGrupoProduto)
    
    setShowDevicesList(false)
    // console.log(item)
    // Execute your action here
  
  };

  const handleOnGmoChange = async (e) => {
    const gmoId = e.target.value
    const gmo = await GmoService.getGmoById(gmoId); 
    
    setValue("enderecoColeta", gmo.gmo.endereco)
    
  }


  const onSubmit = async (data) => {

    console.log(data)

    try {
      await CollectOrderService.createSingleCollectOrder(data);
      toast.success("Ordem de Coleta gerada!");
    } catch (error) {
      toast.error(error.message);      
    }
    
    setModalOpen(!isModalOpen);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    reset();
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-[648px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all mt-6" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 text-left gap-4 bg-gray-800 rounded-t-lg">
                <div className="text-white text-xl font-bold mt-4 mb-2">
                  INICIAR PROCESSO DE COLETA AVULSA
                </div>
              </div>

              <div className="flex flex-col gap-2 mt-2 mx-2 text-[11px]">
                {/* DIV Usuario */}
                <div className="flex flex-col pt-4 px-4 bg-gray-50 border rounded-md relative">
                  <div className="absolute right-4 top-2 text-blue-400 font-bold">
                    <a href="#">Ver mais</a>
                  </div>

                  <div className="flex flex-row gap-8 w-full">
                    <div className="flex items-start gap-1 mb-4">
                      <label className="block text-gray-700 font-bold whitespace-nowrap">
                        Nome Solicitante:
                      </label>
                      <div>
                        {user?.name}
                      </div>
                    </div>
                    <div className="flex items-start gap-1 mb-4">
                      <label className="block text-gray-700 font-bold whitespace-nowrap">
                        RE/Legal Solicitante:
                      </label>
                      <div>
                        {user?.reLegal}
                      </div>
                    </div>
                    <div className="flex items-start gap-1 mb-4">
                      <label className="block text-gray-700 font-bold whitespace-nowrap">
                        UF:
                      </label>
                      <div>{user?.uf}</div>
                    </div>
                  </div>
                </div>

              </div>

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-6">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col text-[11px] gap-4">
                    <div className="flex flex-col items-start gap-1 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Tipo de Coleta:
                      </label>
                      <select
                        // disabled={true}
                        defaultValue="13"
                        {...register("tipoColeta", {
                          validate: (value) => {
                            return value !== "0";
                          },
                        })}
                        className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                          ${
                            errors?.tipoColeta?.type === "validate"
                              ? " border border-red-500 outline-none ring-0"
                              : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                      >
                        <option value="0" disabled>
                          Selecione
                        </option>
                        {filteredTiposColeta.map((tipo, index) => (
                          <option key={index} value={tipo.cod}>
                            {tipo.cod} - {tipo.descricao}
                          </option>
                        ))}
                        {/* { user.role === "vivogestao" &&
                          <option value="05">
                            05 - Material Bom Estoque Sem Cham Atendim
                          </option>
                        } */}
                      </select>
                      {errors?.tipoColeta?.type === "validate" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Tipo de Coleta é obrigatório
                        </p>
                      )}
                    </div>

                    {/* GMO e DEPOSITO */}
                    <div className="flex flex-col gap-2 bg-gray-50 px-2 py-1 border rounded-md">
                      <div className="flex flex-col gap-2">

                        <div className="w-full">
                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                              GMO:
                            </label>
                            <select
                              defaultValue="0"
                              {...register("gmo", {
                                onChange: (e) => { handleOnGmoChange(e) },
                                validate: (value) => {
                                  return value !== "0";
                                },
                              })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                  ${errors?.gmo?.type === "validate"
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                                }
                                  `}
                            >
                              <option value="0" disabled>
                                Escolha um GMO
                              </option>
                              {gmoList?.gmos?.map((gmo) => (
                                <option key={gmo._id} value={gmo._id}>
                                  {gmo.cidade === "SÃO PAULO"
                                      ? `SP - ${gmo.identificador} - ${gmo.endereco}`
                                      : `${gmo.cidade} - ${gmo.endereco}`}
                                </option>
                              ))}
                            </select>
                            {errors?.gmo?.type === "validate" && (
                              <p className="text-red-500 text-xs whitespace-nowrap">
                                GMO é obrigatório
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="w-full flex gap-2">

                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Endereço para coleta:</label>
                            <input
                              // disabled={true}
                              type="text"
                              {...register("enderecoColeta", { required: true })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${errors?.enderecoColeta?.type === "required" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                            `}
                            />
                            {errors?.enderecoColeta?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div>

                          <div className="flex flex-col items-start gap-1 w-4/6">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Complemento:</label>
                            <input
                              // disabled={true}
                              type="text"
                              {...register("enderecoColetaComplemento")}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${errors?.enderecoColetaComplemento?.type === "required" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                            `}
                            />
                            {errors?.enderecoColetaComplemento?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div>

                        </div>

                        <div className="w-full">
                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                              Deposito Coletor:
                            </label>
                            <select
                              defaultValue="0"
                              {...register("deposit", {
                                validate: (value) => {
                                  return value !== "0";
                                },
                              })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                  ${errors?.deposit?.type === "validate"
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                                }
                                  `}
                            >
                              <option value="0" disabled>
                                Escolha um Depósito
                              </option>
                              {depositList?.deposits?.map((deposit) => (
                                <option key={deposit._id} value={deposit._id}>
                                  {deposit.sigla} - {deposit.cidade}
                                </option>
                              ))}
                            </select>
                            {errors?.deposit?.type === "validate" && (
                              <p className="text-red-500 text-xs whitespace-nowrap">
                                Depósito é obrigatório
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="w-full">
                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                              Empresa:
                            </label>
                            <div className="w-full">
                              <select
                                defaultValue=""
                                {...register("empresaTecnico", {
                                  validate: (value) => {
                                    return value !== "0";
                                  },
                                })}
                                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                  ${errors?.deposit?.type === "validate"
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                                }
                                  `}
                              >
                                <option value="" disabled hidden>Selecione uma empresa</option>
                                {companiesList.map((company) => (
                                  <option key={company._id} value={company._id}>
                                    {company.name}
                                  </option>
                                ))}
                              </select>
                              {errors?.deposit?.type === "validate" && (
                                <p className="text-red-500 text-xs whitespace-nowrap">
                                  Empresa é obrigatório
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                      </div>
                      
                    </div>

                    {/* div Cod SAP / Equipamento */}
                    <div className="flex flex-col gap-2 bg-gray-50 px-2 py-1 border rounded-md">
                      <div className="flex justify-between">
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                          Equipamento:
                        </label>
                      </div>

                      <div className="flex gap-2">

                        <div className="flex flex-col items-start gap-1 w-1/3">
                          <label className="block text-gray-700 whitespace-nowrap">Cod. SAP:</label>
                          <input
                          disabled={true}
                            type="text"
                            {...register("codEquipamentoColeta", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.codEquipamentoColeta?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.codEquipamentoColeta?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>

                        {/* <div className="flex flex-col items-start gap-1 w-full">
                          <label className="block text-gray-700 whitespace-nowrap">Equipamento:</label>
                          <input
                            type="text"
                            onChange={handleInputChange}
                            {...register("nomeEquipamentoColeta", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.nomeEquipamentoColeta?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.nomeEquipamentoColeta?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div> */}

                        <div className="flex flex-col items-start gap-1 w-full relative">
                            <label className="block text-gray-700 font-bold whitespace-nowrap">Buscar (nome, código SAP ou part number):</label>
                            <input
                              type="text"
                              {...register('nomeEquipamentoColeta')}
                              placeholder="...digite ao menos 3 caracteres para buscar"
                              onChange={handleInputChange}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                  errors?.nomeEquipamentoColeta?.type === "required" ?
                                  " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {searchResults?.length > 0 && showDevicesList && (
                              <div className="absolute w-full top-full left-0 mt-1 max-h-52 overflow-y-auto bg-white rounded shadow-lg border border-gray-200 z-20">
                                <ul>
                                  {searchResults?.map((item) => (
                                    <li key={item.codigo} onClick={() => handleSelectItem(item)} className="px-4 py-2 cursor-pointer hover:bg-gray-100">
                                      {item.nome}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>

                      </div>

                      <div className="flex gap-2">
                        <div className="flex flex-col items-start gap-1 w-full">
                          <label className="block text-gray-700 whitespace-nowrap">Fabricante:</label>
                          <input
                          disabled={true}
                            type="text"
                            {...register("fabricanteEquipamentoColeta", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.fabricanteEquipamentoColeta?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.fabricanteEquipamentoColeta?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>
                        <div className="flex flex-col items-start gap-1 w-full">
                          <label className="block text-gray-700 whitespace-nowrap">Part Number:</label>
                          <input
                          disabled={true}
                            type="text"
                            {...register("partNumberEquipamentoColeta", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.partNumberEquipamentoColeta?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.partNumberEquipamentoColeta?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>

                      </div>

                      <div className="flex gap-2 w-full justify-between">
                      <div className="flex items-center gap-2">
                        <label className="block text-gray-700 font-bold whitespace-nowrap">
                          Quantidade informada para coleta:
                        </label>
                        <input
                          // disabled={true}
                          type="number"
                          {...register("qtdColeta", {
                            required: true,
                            validate: (value) => {
                              return value > "0"
                            },
                          })}
                          className={`block w-20 rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.qtdColeta
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                        />
                        {errors?.qtdColeta?.type === "validate" && (
                          <p className="text-red-500 text-xs ms-2 w-32">
                            Deve ser maior que zero e menor que a quantidade restante
                          </p>
                        )}
                      </div>

                    </div>

                      
                    </div>

                    <div className="flex flex-col gap-2 bg-gray-50 px-2 py-1 border rounded-md">
                      <div className="flex gap-2">
                        <div className="flex flex-col items-start gap-1 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">Solicitante:</label>
                          <input
                            // disabled={true}
                            type="text"
                            {...register("nomeSolicitante", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.nomeSolicitante?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.nomeSolicitante?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>

                        <div className="flex flex-col items-start gap-1 w-4/6">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">Contato:</label>
                          <input
                            // disabled={true}
                            type="text"
                            {...register("contatoSolicitante", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.contatoSolicitante?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.contatoSolicitante?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Observação da Coleta:
                      </label>
                      <textarea
                        {...register("observacaoColeta", {
                          // required: true,
                        })}
                        className={`
                              w-full h-[80px] p-4 bg-white rounded-lg justify-start items-center inline-flex resize-none 
                              text-gray-600 text-sm font-normal font-['Work Sans']
                              focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                              placeholder:text-gray-400 placeholder:text-sm placeholder:font-normal placeholder:font-['Work Sans'] placeholder:leading-[14.34px]
                              ${
                                errors?.observacaoColeta?.type === "required"
                                  ? "border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                              }
                          `}
                        placeholder={"Observação do Antedimento"}
                      ></textarea>
                      {errors?.observacaoColeta?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div>

                    

                    <button
                      onClick={() => handleSubmit(onSubmit)()}
                      className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                    >
                      Criar Nova Coleta
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

